import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FoundingOffer from "../components/FoundingOffer";
import WhatWeCheck from "../components/WhatWeCheck";
import HowItWorksTender from "../components/HowItWorksTender";
import ExampleFindings from "../components/ExampleFindings";
import Independence from "../components/Independence";
import TenderFAQ from "../components/TenderFAQ";
import TenderForm from "../components/TenderForm";
import { usePageMeta } from "../hooks/usePageMeta";

export default function TenderRedReviewPage() {
  usePageMeta("tenderRedReview");
  const location = useLocation();

  // Handle hash navigation
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const scrollToForm = () => {
    const formSection = document.getElementById("tender-form");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={scrollToForm} />
      
      <main className="pt-20 md:pt-24">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 bg-black text-white">
          <div
            className="absolute inset-0 bg-cover bg-center opacity-20 grayscale"
            style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBibHVlcHJpbnRzJTIwZXN0aW1hdGluZyUyMHRlbmRlciUyMGRvY3VtZW50cyUyMHBsYW5zfGVufDB8fHx8MTc4OTY5MzA5N3ww&ixlib=rb-4.1.0&q=85')",
            }}
          />
          <div className="relative max-w-7xl mx-auto px-6 md:px-12">
            <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
              Flagship Service
            </span>
            <h1 className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl uppercase mt-4 mb-6">
              Tender Red Review
            </h1>
            <p className="font-body text-xl md:text-2xl text-zinc-300 max-w-3xl leading-relaxed">
              Independent pre-submission construction tender review. Fresh eyes before the number goes out.
            </p>
          </div>
        </section>

        {/* Founding Offer */}
        <FoundingOffer />

        {/* What We Check */}
        <WhatWeCheck />

        {/* How It Works */}
        <HowItWorksTender />

        {/* Example Findings */}
        <ExampleFindings />

        {/* Independence */}
        <Independence />

        {/* FAQ */}
        <TenderFAQ />

        {/* Tender Form */}
        <TenderForm />
      </main>

      <Footer />
    </div>
  );
}
